export enum CreateManifestJobFormSteps {
    JOB = 'job',
    CUSTOMER = 'customer',
    DELIVERY_TERMS = 'deliveryTerms',
    ASSIGN_AGENT = 'assignAgent',
}

export const createManifestJobInitialValues: CreateManifestJobFormFields = {
    [CreateManifestJobFormSteps.JOB]: {
        jobId: '',
    },
    [CreateManifestJobFormSteps.CUSTOMER]: {
        customerId: '',
    },
    [CreateManifestJobFormSteps.DELIVERY_TERMS]: {
        incotermCode: '',
    },
    [CreateManifestJobFormSteps.ASSIGN_AGENT]: {
        assignedAgent: '',
    },
};

export type CreateManifestJobFormFields = {
    [CreateManifestJobFormSteps.JOB]: { jobId: string };
    [CreateManifestJobFormSteps.CUSTOMER]: { customerId: string };
    [CreateManifestJobFormSteps.DELIVERY_TERMS]: { incotermCode: string };
    [CreateManifestJobFormSteps.ASSIGN_AGENT]: { assignedAgent: string };
};
